// import React from "react";

// const destinations = [
//   { id: 7, name: "Goa", image: "/images/network/goa.jpg" },
//   { id: 1, name: "Mumbai", image: "/images/network/mumbai.jpg" },
//   { id: 2, name: "Lonavala", image: "/images/network/lonavla.jpg" },
//   { id: 3, name: "Mahabaleshwar", image: "/images/network/mahabaleshwar.jpg" },
//   { id: 4, name: "Shirdi", image: "/images/network/shirdi.jpg" },
//   { id: 5, name: "Nashik", image: "/images/network/nashik.jpg" },
//   { id: 6, name: "Kolhapur", image: "/images/network/kolhapur.jpg" },
//   { id: 8, name: "Ratnagiri", image: "/images/network/ratnagiri.jpg" },
//   { id: 9, name: "Lavasa", image: "/images/network/lavasa.jpg" },
//   { id: 10, name: "Alibag", image: "/images/network/alibag.jpg" },
//   { id: 11, name: "Satara", image: "/images/network/satara.jpg" },
//   { id: 12, name: "Aurangabad", image: "/images/network/aurangabad.jpg" },
// ];

// const OurNetwork = () => {
//   return (
//     <>

//   <div className="breadcrumb-bar">
//         <div className="container">
//           <div className="row align-items-center text-center">
//             <div className="col-md-12 col-12">
//               <h2 className="breadcrumb-title text-white">
//                 Our Network
//               </h2>
//             </div>
//           </div>
//         </div>
//       </div>



//       {/* SECTION */}
//       <section className="ournet-section">
//         <div className="container">
//           <div className="row">
//             {destinations.map((place) => (
//               <div className="col-lg-3 col-md-4 col-sm-6 mb-4" key={place.id}>
                
//                 {/* CARD */}
//                 <div className="ournet-card">

//                   <img
//                     src={place.image}
//                     alt={place.name}
//                     className="ournet-img"
//                   />

//                   {/* OVERLAY */}
//                   <div className="ournet-overlay">
//                     <h3 className="ournet-title">{place.name}</h3>
//                   </div>

//                 </div>

//               </div>
//             ))}
//           </div>
//         </div>
//       </section>
//     </>
//   );
// };

// export default OurNetwork;











import React, { useState } from "react";
import OurNetworkMap from "./OurNetworkMap";
import Ournetworkmap from "./OurNetworkMap";

const destinations = [
  { id: 1, name: "Mumbai", image: "/images/network/mumbai.jpg" },
  { id: 2, name: "Goa", image: "/images/network/goa.jpg" },
  { id: 3, name: "Lonavala", image: "/images/network/lonavla.jpg" },
  { id: 4, name: "Mahabaleshwar", image: "/images/network/mahabaleshwar.jpg" },
  { id: 5, name: "Shirdi", image: "/images/network/shirdi.jpg" },
  { id: 6, name: "Nashik", image: "/images/network/nashik.jpg" },
  { id: 7, name: "Kolhapur", image: "/images/network/kolhapur.jpg" },
  { id: 8, name: "Ratnagiri", image: "/images/network/ratnagiri.jpg" },
  { id: 9, name: "Lavasa", image: "/images/network/lavasa.jpg" },
  { id: 10, name: "Alibag", image: "/images/network/alibag.jpg" },
  { id: 11, name: "Satara", image: "/images/network/satara.jpg" },
  { id: 12, name: "Aurangabad", image: "/images/network/aurangabad.jpg" },
];

const OurNetwork = () => {
  const [selectedCity, setSelectedCity] = useState(destinations[0]);

  return (
    <>
      {/* HEADER */}
      <div className="breadcrumb-bar">
        <div className="container text-center">
          <h2 className="breadcrumb-title text-white">Our Network</h2>
        </div>
      </div>
<Ournetworkmap/>


      <section className="network-section">
        <div className="container">

          {/* CITY CHIPS */}
          <div className="city-scroll">
            {destinations.map((place) => (
              <button
                key={place.id}
                onClick={() => setSelectedCity(place)}
                className={`city-chip ${
                  selectedCity.id === place.id ? "active" : ""
                }`}
              >
                {place.name}
              </button>
            ))}
          </div>

          {/* SELECTED CITY VIEW */}
          <div className="network-card">
            <img
              src={selectedCity.image}
              alt={selectedCity.name}
              className="network-img"
            />

            <div className="network-info">
              <h3>{selectedCity.name}</h3>
              <p>
                Premium cab service available for <b>{selectedCity.name}</b>.
                Book your ride now for safe and comfortable travel.
              </p>

              {/* <button className="book-btn">
                Book Cab to {selectedCity.name}
              </button> */}
            </div>
          </div>

        </div>
      </section>
      
    </>
  );
};

export default OurNetwork;